import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Features from "../pages/features/page";
import Pricing from "../pages/pricing/page";
import Terms from "../pages/terms/page";
import Safety from "../pages/safety/page";
import Waitlist from "../pages/waitlist/page";
import CFIsPage from "../pages/cfis/page";
import Privacy from "../pages/privacy/page";
import EarlyAccess from "../pages/early-access/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/features",
    element: <Features />,
  },
  {
    path: "/pricing",
    element: <Pricing />,
  },
  {
    path: "/for-cfis",
    element: <CFIsPage />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "/safety",
    element: <Safety />,
  },
  {
    path: "/waitlist",
    element: <Waitlist />,
  },
  {
    path: "/early-access",
    element: <EarlyAccess />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;